/**
 * Utility functions for localStorage operations
 */

/**
 * Safely get and parse data from localStorage
 * @param {string} key - The localStorage key
 * @returns {any|null} - Parsed data or null if not found/invalid
 */
export const getStorageItem = (key) => {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  } catch (error) {
    console.error(`Error parsing localStorage item '${key}':`, error);
    localStorage.removeItem(key); // Clean up corrupted data
    return null;
  }
};

/**
 * Safely set data to localStorage
 * @param {string} key - The localStorage key
 * @param {any} data - The data to store
 * @returns {boolean} - Success status
 */
export const setStorageItem = (key, data) => {
  try {
    localStorage.setItem(key, JSON.stringify(data));
    return true;
  } catch (error) {
    console.error(`Error setting localStorage item '${key}':`, error);
    return false;
  }
};

/**
 * Remove item from localStorage
 * @param {string} key - The localStorage key
 */
export const removeStorageItem = (key) => {
  try {
    localStorage.removeItem(key);
    return true;
  } catch (error) {
    console.error(`Error removing localStorage item '${key}':`, error);
    return false;
  }
};

/**
 * Check if user has valid login credentials in localStorage
 * @returns {boolean} - True if valid credentials exist
 */
export const hasValidLoginCredentials = () => {
  const loginSuccess = getStorageItem("loginSuccess");
  return !!(loginSuccess?.user?._id && loginSuccess?.token);
};

/**
 * Clear all auth-related localStorage items
 */
export const clearAuthStorage = () => {
  removeStorageItem("loginSuccess");
  removeStorageItem("userCredentials");
};
